import csosnMetadata from './data/metadata.json';
import type { CsosnDataVersion } from './types.js';

export const CSOSN_DATA_VERSION: CsosnDataVersion = csosnMetadata as CsosnDataVersion;
